import React from 'react';
import { createRoot } from 'react-dom/client';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css'; //if using mantine date picker features
import 'mantine-react-table/styles.css';
import { AlertProvider } from './context/AlertContext';
import 'leaflet/dist/leaflet.css';

// inicializador del servicio de Firebase
//import './messaging_init_in_sw';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import App from './App';
import { store } from 'store';
//Notification
// style + assets
import 'assets/scss/style.scss';
import config from './config';
import * as serviceWorker from './serviceWorker';

// ==============================|| REACT DOM RENDER  ||============================== //
// optional configuration

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <Provider store={store}>
        <BrowserRouter basename={config.basename}>
            <AlertProvider>
                <App />
            </AlertProvider>
        </BrowserRouter>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
